import { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import React from 'react';
import { Typography } from '@mui/material';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_Zuwendungsantrag_Paths.json';
import { concat } from 'lodash';
const P = Schema.attributes;

const Anlagen: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<Typography variant="h3">Anlagen</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};

export default Anlagen;

const formStruc = [
	{
		fields: [
			P.Sonstiges_Anlagen_Kopie_Personalausweis,
			P.Sonstiges_Anlagen_Anlagen_Sind_Beizufuegen_Kosten_Zeitplan,
			P.Sonstiges_Anlagen_Gemeinnuetzigkeit_Freistellungsbescheid,
			P.Sonstiges_Anlagen_Koerpersch_Steuer_Freistellungsbescheid_V,
		],
		userProps: { direction: 'column', columnToDivide: 2 },
	},
	{
		fields: [P.Sonstiges_Anlagen_Angabe_Zu_Eigentumsverhaeltnissen],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];

export const GetAnlagenFormStruc = () => {
	return concat(formStruc);
};
